import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-subscription',
  standalone: false,
  
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.css'
})
export class SubscriptionCalculatorComponent {
  subscriptionForm!: FormGroup;
  totalPrice=0;
  constructor(private fb:FormBuilder,private apiService:ApiService){
    this.subscriptionForm = this.fb.group({
      project_name: ['', Validators.required],
      domains: [[], Validators.required],
      land_size: [null],
      built_up_area: [null],
      built_up_unit: ['Square Feet'],
      duration: [1, Validators.required],
      users: [1, Validators.required]
    });
  }
  onSubmit() {
    if (this.subscriptionForm.invalid) return;
  this.apiService.subscribePackage(this.subscriptionForm.value)
    .subscribe((res: any) => {
      this.totalPrice = res.total_price;
      // this.snackBar.open(`Subscription saved! Total Price: ₹${res.total_price}`, 'Close', { duration: 4000 });
    });
    // this.http.post('/api/subscriptions'
  }
}
